<template>
  <span
    class="brand-logo-wrap"
    :style="{ height: logoHeight + 'px' }"
  >
    <img
      v-show="loaded"
      class="brand-logo"
      src="/logos/SEOWRITEE-LOGO-4.png"
      alt="SEOWRITEE"
      :height="logoHeight"
      :width="logoWidth"
      @load="loaded = true"
      @error="loaded = false"
    >
    <span
      v-if="!loaded"
      class="brand-logo-text"
      :style="{ fontSize: Math.round(logoHeight * 0.62) + 'px' }"
    >SEOWRITEE</span>
  </span>
</template>

<script lang="ts">
    import Vue from 'vue';

    export default Vue.extend({
        name: 'BrandLogo',
        props: {
            height: {
                type: [Number, String],
                default: 30
            }
        },
        data: () => ({
            loaded: false
        }),
        computed: {
            logoHeight(): number {
                const n = Number(this.height);
                return Number.isFinite(n) && n > 0 ? n : 30;
            },
            logoWidth(): number {
                return Math.round(this.logoHeight * (777 / 123));
            }
        }
    });
</script>

<style scoped lang="sass">
.brand-logo-wrap
    display: inline-flex
    align-items: center
    flex-shrink: 0

.brand-logo
    display: block
    width: auto
    height: 100%
    object-fit: contain

.brand-logo-text
    font-weight: 700
    letter-spacing: 0.04em
    line-height: 1
    color: inherit
</style>
